module.exports = __webpack_public_path__ + "static/img/homePageLogo.3594913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePageLogo.png
// module id = p8Rx
// module chunks = 1